<div class="fpui-helper pointer"><i class="fp4 fp4-circle-info" @click="$emit('click')" :class="className" v-tooltip="options" :style="style"></i></div>